import jquerySelectric from 'selectric';
import '../form';

/**
 *  Javascript utilisé par le bloc "Onglet" présent sur la home et sur les landing page
 * 
 */
 (function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude, { bloc_onglets : Object.assign({}, w.Completude.bloc_onglets, {
                
        /**
         * Initialisation 
         */
        InitBlocOnglets() {
               
            Completude.bloc_onglets.$formCoursParticuliers = Completude.SetFormValidation(jQuery('#form-cours-particuliers'));

            $("#btn-voir-mon-tarif").on('click',function() {
                // Validation des données
               Completude.bloc_onglets.clicVoirMonTarif();                
            });

            //Préchargement
            let oldValues = Completude.GetStorage("form-demande-tarifs");                
            if (typeof(oldValues)!=='undefined' && oldValues!==null) {
                try {
                    let data = JSON.parse(oldValues);
                    $('#field-class').val(data.IdClasse).selectric('refresh');                    
                    $("#field-address").SetLocalisation(data.localisation);                    
                }
                catch(e) {}
            }
            
        }, 


        /**
        * Clic sur le bouton "Voir mon tarif"        
        */
        clicVoirMonTarif: function () {
            if (!Completude.bloc_onglets.$formCoursParticuliers.validate()) {
                return;
            }
            let self = this;
            //On regarde si l'adresse est déservie.
            jQuery("#form-cours-particuliers .row").loading(
                jQuery.ajax({
                    url: disko_ajax_object.ajaxurl,
                    type: 'post',
                    data: {
                        'action'    : 'wp_est_desservie',
                        'Latitude'       : window.autocomplete.localisation.lat,
                        'Longitude'       : window.autocomplete.localisation.lng,
                        'Ville'      : window.autocomplete.localisation.city                            
                    },
                    success: function (response) {                        
                        if (response.success && response.data==='true') {
                            // Ecrase les données de préchargement du tarif
                            // Puis redirige vers la page demande de tarif
                            var  prechargementDemandeTarif = Completude.GetStorage("form-demande-tarifs");
                            if (prechargementDemandeTarif!==null) {
                                prechargementDemandeTarif = Object.assign(prechargementDemandeTarif, {IdClasse : $("#field-class").val()},{ 'localisation' : autocomplete.localisation});
                            } else {
                                prechargementDemandeTarif = Object.assign({IdClasse : $("#field-class").val()},{ 'localisation' : autocomplete.localisation});
                            }
                            window.sessionStorage.setItem("redirectfromhome",true);
                            Completude.SetStorage('form-demande-tarifs',   prechargementDemandeTarif);                            
                            window.location = "/demande-de-tarif/";
                        } 
                        else {                                                                                                                                                                    
                            // Adresse non désservie
                            jQuery('#popup-error1-link').click();
                            Completude.TagManagerTunnel('demandetarif/step-0',{'event' : 'GTMerror' , 'ErrorType': "Adresse non désservie"});
                        }
                    }
                }).promise()
            );

        },
       
    })});       
})(window);

jQuery(function() {
    try {
        if (jQuery("#section-bloc-onglets").length>0) {        
            window.Completude.bloc_onglets.InitBlocOnglets();         
        }
    }   
    catch (e) {
        console.error(e);
    }
});